import { Component, Input, inject } from "@angular/core";
import { ControlContainer, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldAppearance } from "@angular/material/form-field";
import { StartEnd } from "../../models";
import { CustomFormControl, CustomFormControlProps, CustomFormGroup } from "../../utils";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { MatDatepickerModule } from "@angular/material/datepicker";


@Component({
    selector: 'tilby-date-range-picker-input',
    templateUrl: './tilby-date-range-picker-input.component.html',
    styleUrls: ['./tilby-date-range-picker-input.component.scss'],
    standalone: true,
    imports: [MatInputModule, MatDatepickerModule, MatIconModule, ReactiveFormsModule, MatButtonModule, NgStyle, NgIf, NgForOf, NgClass, TranslateModule],
})
export class TilbyDateRangePickerInputComponent { 
    private parentControl = inject(ControlContainer);

    @Input({required:true}) formControlLabel!: string | number;
    @Input() appearance: MatFormFieldAppearance = 'fill';
    @Input() hintAlign: StartEnd ='end';
    @Input() flex: number = 1;
    @Input() dateEndControllerLabel!: string | undefined;

    protected parentForm!:CustomFormGroup<any>;
    protected control!:CustomFormControl;
    protected customProps: CustomFormControlProps<any,any> = new CustomFormControlProps();

    ngOnInit(){
        this.parentForm=this.parentControl.control as CustomFormGroup<any>;
        this.control=this.parentForm?.controls[this.formControlLabel] as CustomFormControl;
        this.customProps=this.control.customProps;
    }
}
